import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterHealthStatus } from './z-printer-health-status';

@MappedClass()
export class ZPrinterPosHealthEntry {
  @MappedProperty()
  id?: string;

  @MappedProperty()
  ip?: string;

  @MappedProperty()
  name?: string;

  @MappedProperty()
  network_reachable?: boolean;

  @MappedProperty()
  status?: ZPrinterHealthStatus;
}
